import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import {
  UserGameProfileEffects,
  UserGameProfileFacade,
  fromUserGameProfile,
} from './+state/user-game-profile';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature(
      fromUserGameProfile.USER_GAME_PROFILE_FEATURE_KEY,
      fromUserGameProfile.userGameProfileReducer,
    ),
    EffectsModule.forFeature([UserGameProfileEffects]),
  ],
  providers: [UserGameProfileFacade],
})
export class UserGameProfileDataAccessModule {}
